export default {"src":"/_next/static/media/infoPrimary.2e582625.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};